import { render } from "./formGenerator.vue?vue&type=template&id=5d3924fd&scoped=true"
import script from "./formGenerator.vue?vue&type=script&lang=js"
export * from "./formGenerator.vue?vue&type=script&lang=js"

import "./formGenerator.vue?vue&type=style&index=0&id=5d3924fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3924fd"]])

export default __exports__